export default __webpack_public_path__ + "static/media/le_touquet2.a720c960.jpg";